import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenReviewDetail from '../../../../../components/link/OpenReviewDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 상품 후기에 연결된 상품 후기 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const { isFilter, filterOption, sortOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'별점'} />,
      dataIndex: 'rate',
      sorter: isFilter,
      sortOrder: sortOption['rate'],
    },
    {
      title: <TableColumnTitle title={'상품 후기 ID'} filterValue={filterOption.reviewId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품 후기 ID 검색'}
          option={filterOption.reviewId}
          confirm={confirm}
          onFilter={(reviewId) => onFilter({ reviewId })}
        />
      ),
      render: (value) => <OpenReviewDetail text={value} reviewId={value} />,
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} filterValue={filterOption.storeId} />,
      dataIndex: 'storeId',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드 ID 검색'}
          option={filterOption.storeId}
          confirm={confirm}
          onFilter={(storeId) => onFilter({ storeId })}
        />
      ),
      render: (value) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} filterValue={filterOption.storeName} />,
      dataIndex: 'storeName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드명 검색'}
          option={filterOption.storeName}
          confirm={confirm}
          onFilter={(storeName) => onFilter({ storeName })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상품 ID'} filterValue={filterOption.productId} />,
      dataIndex: 'productId',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품 번호 검색'}
          option={filterOption.productId}
          confirm={confirm}
          onFilter={(productId) => onFilter({ productId })}
        />
      ),
      render: (value) => <OpenProductDetail text={value} productId={value} />,
    },
    {
      title: <TableColumnTitle title={'상품명'} filterValue={filterOption.productName} />,
      dataIndex: 'productName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품명 검색'}
          option={filterOption.productName}
          confirm={confirm}
          onFilter={(productName) => onFilter({ productName })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'작성 일자'} />,
      dataIndex: 'createDate',
      sorter: isFilter,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};
